<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20.486"
    height="20.026"
    viewBox="0 0 20.486 20.026"
  >
    <g transform="translate(-432.257 -557.987)">
      <path
        d="M437.95,578.013h-4.193a.5.5,0,0,1-.5-.5v-8.156a.5.5,0,0,1,.5-.5h4.193a.5.5,0,0,1,.5.5v8.156A.5.5,0,0,1,437.95,578.013Zm-3.693-1h3.193v-7.156h-3.193Z"
        transform="translate(-1)"
        fill="#777"
      />
      <path
        d="M444.6,578.013H440.4a.5.5,0,0,1-.5-.5V564.668a.5.5,0,0,1,.5-.5H444.6a.5.5,0,0,1,.5.5v12.845A.5.5,0,0,1,444.6,578.013Zm-3.695-1H444.1V565.168H440.9Z"
        fill="#777"
      />
      <path
        d="M451.243,578.013H447.05a.5.5,0,0,1-.5-.5V558.487a.5.5,0,0,1,.5-.5h4.193a.5.5,0,0,1,.5.5v19.026A.5.5,0,0,1,451.243,578.013Zm-3.693-1h3.193V558.987H447.55Z"
        transform="translate(1)"
        fill="#777"
      />
    </g>
  </svg>
</template>
